// FearGreedWidget/FearGreedMeterBar.jsx
// Pure painter — digital block-meter. No state, no fetch logic.
import React from 'react';
import fearGreedConst from './fearGreedConst';
import FearGreedSegmentCalculator from './FearGreedSegmentCalculator';

/**
 * @param {{value:number}} props - value 0-100
 * @returns {JSX.Element}
 */
function FearGreedMeterBar({ value }) {
    const blockCount = fearGreedConst.METER_BLOCK_COUNT;
    const litCount = Math.round((value / 100) * blockCount);

    return (
        <div className="fgw-meter">
            {Array.from({ length: blockCount }, (_, i) => {
                const lit = i < litCount;
                const color = lit ? FearGreedSegmentCalculator.getBlockColor(i, blockCount) : 'var(--surface-1)';
                return <div key={i} className="fgw-meter-block" style={{ background: color, borderColor: lit ? 'transparent' : 'var(--border)' }} />;
            })}
        </div>
    );
}

export default FearGreedMeterBar;
